

export default function CustomerPortalWelcome() {
    return (
        <div className="min-h-screen bg-gray-400 flex flex-col items-center justify-center py-10 w-full">
            <div className="bg-white shadow-lg rounded-lg p-8 max-w-2xl text-center">
                <h1 className="text-4xl font-bold text-gray-800 mb-4">Welcome to the Customer Portal</h1>
                <p className="text-lg text-gray-600">
                    Here, you can view your invoices, quotes, and price lists.
                </p>
            </div>
        </div>
    );
}